import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route,Switch,Redirect} from 'react-router-dom'
import _ from 'lodash';
import DashboardLayout from './Dashboard/DashboardLayout';
import PublicLayout  from './Public/PublicLayout';
import SurveyLayout from './Survey/SurveyLayout'
import OrganisationLayout from './Organisation/OrganisationLayout'



import {publicRoutes,surveyRoutes} from "../routes"

import {UserIsAuthenticated} from "../utils/AuthRouter"


class Layout extends Component{

    constructor(props){
        super(props)
    }
    render(){


        //if(!user.verified){return(<div>Loading..</div>)}

        return(
            <BrowserRouter>
                    <Switch>
                        {_.map(publicRoutes, (routes,key)=>{
                            const {component,path,title} = routes
                            return (

                                <Route exact path={path}
                                       key={key}
                                       render={ (route) =>
                                           <PublicLayout
                                               title={title}
                                               Component={component}
                                               route={route}
                                           />
                                       }
                                />
                            )
                        })
                        }

                    <Route path="/organisation/:id" component={UserIsAuthenticated(OrganisationLayout)}/>
                        <Route path="/survey/:id" component={UserIsAuthenticated(SurveyLayout)}/>
                    <DashboardLayout/>

                    </Switch>
            </BrowserRouter>
        )
    }
}

export default connect(
    ({ firebase: { auth,profile } }) => ({ auth: auth,profile:profile })
)(Layout);


// WEBPACK FOOTER //
// ./src/layouts/index.jsx